import { FC, useEffect } from 'react'
import { classes, stylesheet } from 'typestyle'
import { Link } from 'react-router-dom'

/* Common ======================================================================================= */
import { get } from '../../__aeki__/share/find'

/* Hooks ======================================================================================== */
import useFetch from '../../__aeki__/hooks/use-fetch'

/* Components =================================================================================== */
import AppLayout, { MAX_WIDTH } from './layout'
import Footer from '../__home__/components/footer'
import Skeleton from '../../__aeki__/components/skeleton'
import { A } from '../../__aeki__/components/a'
import { Box } from '../../__aeki__/components/box/box.component'
import { Heading } from '../../__aeki__/components/text/heading.component'
import { Info } from '../posts/components/info'
import { Line } from '../../__aeki__/components/line'
import { Loader } from '../../__aeki__/components/loader'
import { Text } from '../../__aeki__/components/text/text.component'
import { Title } from '../../__aeki__/components/text/title.component'
import { VisibleFade } from '../__home__/components/visible/visible-fade'
import { VisibleOpacity } from '../__home__/components/visible/visible-opacity'

/* Styles ======================================================================================= */
import { createMediaQuery } from '../../__aeki__/components/style-class/style-class.utils'
import { mb8 } from '../../__aeki__/styles/styleset/margin/mb8'
import { mt20 } from '../../__aeki__/styles/styleset/margin/mt20'
import { paddingVerticalOuter } from '../../__aeki__/styles/default/padding'
import { pt40 } from '../../__aeki__/styles/styleset/padding/pt40'
import { rowsmi } from '../../__aeki__/styles/styleset/row/rowsmi'
import { textCenter } from '../../__aeki__/styles/styleset/text-center/textCenter'
import { w100smi } from '../../__aeki__/styles/styleset/width/w100smi'
import { w30 } from '../../__aeki__/styles/styleset/width/w30'
import { w80 } from '../../__aeki__/styles/styleset/width/w80'
import { p12 } from '../../__aeki__/styles/styleset/padding/p12'
import { mt8 } from '../../__aeki__/styles/styleset/margin/mt8'
import { mb4 } from '../../__aeki__/styles/styleset/margin/mb4'
import { mt40 } from '../../__aeki__/styles/styleset/margin/mt40'

const Blog: FC<any> = (props: any) => {
  const { inject, eject } = props
  const injection = inject()

  const [contents, $contents] = useFetch<any>(
    Object.keys(injection).length
      ? injection
      : {
          data: [],
        },
    {
      url: `${process.env.REACT_APP_API_URL}/a/docs`,
    },
  )

  useEffect(() => {
    return () => {
      eject()
    }
  }, [])

  useEffect(() => {
    if (contents.mounted && Object.keys(injection).length === 0) {
      $contents.get()
    }
  }, [contents.mounted])

  const parentMap: any = {}
  const parentChildrenMap: any = {}

  contents.payload.data.map((item: any) => {
    if (!item.body.parent) {
      parentMap[item.id] = item
      parentChildrenMap[item.id] = []
    } else {
      parentChildrenMap[item.body.parent.id].push(item)
    }
  })

  return (
    <AppLayout.render
      head={{
        title: 'Learn about childcare - ChildAt.io',
        description:
          'Choosing a childcare is a big decision with many different considerations. We aim to equip the parents with information and the tools to find the right childcare for their child.',
      }}
      headerProps={{
        maxWidth: MAX_WIDTH,
        scrollEffect: true,
        allowToggleEffect: true,
      }}
      content={
        <>
          <Box baseline="secondary" className={STYLES.containerHero} row>
            <Box
              baseline="none"
              className={STYLES.containerHeroContent}
              flex
              alignCenterX
              alignCenterY
            >
              <Box
                className={classes(paddingVerticalOuter)}
                baseline="none"
                maxWidth={MAX_WIDTH}
                centerAutoX
                fullWidth
                row
              >
                <VisibleOpacity>
                  <Box className={classes(textCenter, rowsmi)} row baseline="none" alignCenterX>
                    <Text baseline="primary" className={mb8} size="lg" tag={'h2'}>
                      Get started
                    </Text>
                    <Title className={textCenter} size="md" semiBold tag={'h1'} crank>
                      Documentation
                    </Title>
                  </Box>
                </VisibleOpacity>
              </Box>
            </Box>
          </Box>
          <Info maxWidth={MAX_WIDTH} label="Subscribe" labelWidth={80} icon="error">
            <Text size="sm">
              Sign up with us so you can get notified of our posts by clicking{' '}
              <A to={'/a/signin'}>
                <Text size="sm" link>
                  here!
                </Text>
              </A>
            </Text>
          </Info>
          <Box className={pt40} baseline="surface" row>
            <VisibleFade>
              <Box
                baseline="none"
                className={paddingVerticalOuter}
                maxWidth={MAX_WIDTH}
                centerAutoX
                row
                fullWidth
              >
                <Loader
                  timeout={0}
                  loaded={contents.payload.data.length > 0}
                  skeleton={
                    <>
                      <Skeleton className={classes(w100smi, w80, mb8)} height={34} />
                      <Skeleton className={classes(w100smi, w30, mb8)} height={19} />
                      <Line className={classes(mt20)} dark />
                    </>
                  }
                  component={Object.keys(parentMap).map((key: any) => {
                    const parent = parentMap[key]
                    const name = get('body.name', parent, 'string')

                    return (
                      <Box key={key}>
                        <Box baseline="none" key={key} rounded row>
                          <Box baseline="none" as={<Link to={`/a/docs/${parent.id}`} />} row>
                            <Heading size="xs" semiBold className={mb8} as={<h3 />} shrink>
                              {name}
                            </Heading>
                            <Line className={classes(mb4)} />
                          </Box>
                        </Box>
                        {parentChildrenMap[key].map((item: any, key: any) => {
                          return (
                            <Box
                              baseline="background"
                              className={classes(p12, mt8)}
                              key={key}
                              rounded
                              row
                            >
                              <Box baseline="none" as={<Link to={`/a/docs/${item.id}`} />} row>
                                <Heading size="sm" semiBold as={<h2 />}>
                                  {item.body.name}
                                </Heading>
                              </Box>
                            </Box>
                          )
                        })}
                      </Box>
                    )
                  })}
                />
              </Box>
            </VisibleFade>
            <Line className={mt40} />
            <Box className={classes(pt40)} baseline="background">
              <Footer />
            </Box>
          </Box>
        </>
      }
    />
  )
}

/* Styles ======================================================================================= */
const STYLES = stylesheet({
  containerHero: {
    marginTop: -56,
    paddingTop: 56,
  },
  containerHeroContent: {
    height: 'calc(40vh)',
    minHeight: 320,
    ...createMediaQuery.sm({
      minHeight: 'calc(100vh - 97px)',
    }),
  },
  lineHero: {
    opacity: 0.1,
  },
})

export default Blog
